export class ProjectStateType
{
    constructor (public name: string, public status: boolean)
    {
    }
}

export class ProjectState
{
    public static open: ProjectStateType = new ProjectStateType('open', false);
    public static closed: ProjectStateType = new ProjectStateType('closed', true);
}
